export default __webpack_public_path__ + "static/media/french-rose.9b8d7497.png";